import { render, staticRenderFns } from "./LinkList.vue?vue&type=template&id=3552367e"
import script from "./LinkList.vue?vue&type=script&lang=js"
export * from "./LinkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports